import React from 'react';
import PagePublic from 'components/templates/PagePublic';

import CheckoutComplete from 'components/cart/CheckoutComplete';

export default () => {
  return (
    <PagePublic >
      <CheckoutComplete />
    </PagePublic>
  )
}
